import { Group, ImageMantine, Text } from 'ui';

const LOGO_URL = 'https://s3.amazonaws.com/com.givebacks.public/icons/Stripe.svg';
const StripeSecurelyIntegratedWith = () => {
  return (
    <Group justify="center" gap="xs" wrap="nowrap">
      <Text
        size="xs"
        fw={500}
        c="gray.8"
        style={{ display: 'flex', alignItems: 'center', fontFamily: 'Montserrat, sans-serif' }}
      >
        Securely integrated with
      </Text>
      <ImageMantine h={20} src={LOGO_URL} />
    </Group>
  );
};

export { StripeSecurelyIntegratedWith };
